import { type CSSProperties, type ReactNode } from 'react';

interface SectionProps {
    title: string;
    children: ReactNode;
    className?: string;
    style?: CSSProperties;
}

export function Section({
    title,
    children,
    className,
    style,
}: SectionProps): ReactNode {
    return (
        <div className={`flex flex-column gap-2 ${className ?? ''}`} style={style}>
            <h3 className="text-p70 mb-2">{title}</h3>
            {children}
        </div>
    );
}
